import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { connect } from 'react-redux';
import { Button, DeprecatedIcon } from '@vinted/web-ui';
import { FormattedMessage } from 'components/@support';
import SeparatedList from 'components/SeparatedList';
import { actions } from 'state/user-feedback/slice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapActionsToProps = {
  feedbackToggleReply: actions.feedbackToggleReply,
  feedbackToggleDelete: actions.feedbackToggleDelete
};
const connector = connect(null, mapActionsToProps);

class FeedbackActions extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleReply", () => {
      const {
        id,
        feedbackToggleReply
      } = this.props;
      return feedbackToggleReply({
        feedbackId: id
      });
    });

    _defineProperty(this, "handleDelete", () => {
      const {
        id,
        feedbackToggleDelete
      } = this.props;
      return feedbackToggleDelete({
        feedbackId: id
      });
    });
  }

  render() {
    const {
      canReply,
      canChange,
      canDelete,
      editFeedbackUrl
    } = this.props;
    return /*#__PURE__*/_jsxs(SeparatedList, {
      children: [canReply && /*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "user.feedback.reply"
        }),
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "arrow-back",
          size: DeprecatedIcon.Size.XSmall,
          color: "parent"
        }),
        inline: true,
        size: Button.Size.Small,
        theme: "muted",
        onClick: this.handleReply
      }), canChange && /*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "user.feedback.edit"
        }),
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "pencil",
          size: DeprecatedIcon.Size.XSmall,
          color: "parent"
        }),
        inline: true,
        size: Button.Size.Small,
        theme: "muted",
        url: editFeedbackUrl
      }), canDelete && /*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "user.feedback.delete"
        }),
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "x",
          size: DeprecatedIcon.Size.XSmall,
          color: "parent"
        }),
        inline: true,
        size: Button.Size.Small,
        theme: "muted",
        onClick: this.handleDelete
      })]
    });
  }

}

export default connector(FeedbackActions);